export const homeCarouselImages = [
    {src: "https://res.cloudinary.com/djnufglwv/image/upload/v1764819028/WhatsApp_Image_2025-11-28_at_23.01.30_vdpdm3.jpg", alt: 'Imagen 1'},
    {src: "https://res.cloudinary.com/djnufglwv/image/upload/v1764819028/WhatsApp_Image_2025-11-28_at_23.01.30_1_qafqok.jpg", alt: 'Imagen 2'},
    //añadir mas luego
];

/*export const servicesImages= {
    service1: require('./Service1.jpg'),
    service2: require('./Service2.jpg'),
}*/

export const DoctorImage = "https://res.cloudinary.com/djnufglwv/image/upload/v1735323427/Doctor_mkwcsc.jpg"

export const logo = "https://res.cloudinary.com/djnufglwv/image/upload/v1735323645/Physio_Active_p9wnnd.png"

export const socialMediaIcons = {
    facebook: "https://res.cloudinary.com/djnufglwv/image/upload/v1735330248/facebook_rsy9i6.png",
    instagram: "https://res.cloudinary.com/djnufglwv/image/upload/v1735330248/instagram_vlefji.png",
    linkedin: "https://res.cloudinary.com/djnufglwv/image/upload/v1735330249/linkedin_jeuyr5.png",
    tiktok: "https://res.cloudinary.com/djnufglwv/image/upload/v1735330250/tiktok_qks6fn.png",
    youtube: "https://res.cloudinary.com/djnufglwv/image/upload/v1735330247/youtube_km8yma.png"
}

export const homeImagesSection2 = {
    imagen1: "https://res.cloudinary.com/djnufglwv/image/upload/v1736137387/frontend-images/u9ajyogmnamtxnzkdm0u.jpg",
    imagen2: "https://res.cloudinary.com/djnufglwv/image/upload/v1736137387/frontend-images/is08sbaflx6l556q7f3o.jpg",
    //añadir mas luego
};